/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ModuleHandle model module.
 * @module model/ModuleHandle
 * @version V1
 */
class ModuleHandle {
    /**
     * Constructs a new <code>ModuleHandle</code>.
     * @alias module:model/ModuleHandle
     */
    constructor() { 
        
        ModuleHandle.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ModuleHandle</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ModuleHandle} obj Optional instance to populate.
     * @return {module:model/ModuleHandle} The populated <code>ModuleHandle</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ModuleHandle();

            if (data.hasOwnProperty('mdStreamVersion')) {
                obj['mdStreamVersion'] = ApiClient.convertToType(data['mdStreamVersion'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ModuleHandle</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ModuleHandle</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} mdStreamVersion
 */
ModuleHandle.prototype['mdStreamVersion'] = undefined;






export default ModuleHandle;

